<template>
  <div class="animated fadeIn">
    <b-card header="Relatórios EAD">
      <b-tabs content-class="mt-3" v-model="activeTab">
        <!-- RELATÓRIOS DE DESEMPENHO -->
        <b-tab title="Desempenho">
          <h5 class="mb-3">Relatórios de Desempenho e Conclusão</h5>
          <b-row>
            <b-col md="6" class="mb-3">
              <b-card>
                <h6>Taxa de Conclusão por Curso</h6>
                <p class="text-muted">
                  Percentual de alunos que completaram vs iniciaram cada curso
                </p>
                <b-button
                  variant="primary"
                  size="sm"
                  @click="loadCompletionByCourse"
                >
                  <i class="fa fa-chart-pie"></i> Gerar Relatório
                </b-button>
              </b-card>
            </b-col>
            <b-col md="6" class="mb-3">
              <b-card>
                <h6>Tempo Médio de Conclusão</h6>
                <p class="text-muted">
                  Quanto tempo os alunos levam para finalizar cada curso
                </p>
                <b-button
                  variant="primary"
                  size="sm"
                  @click="loadAverageCompletionTime"
                >
                  <i class="fa fa-clock-o"></i> Gerar Relatório
                </b-button>
              </b-card>
            </b-col>
            <b-col md="6" class="mb-3">
              <b-card>
                <h6>Taxa de Aprovação/Reprovação</h6>
                <p class="text-muted">Desempenho dos alunos em avaliações</p>
                <b-button variant="primary" size="sm" @click="loadApprovalRate">
                  <i class="fa fa-check-circle"></i> Gerar Relatório
                </b-button>
              </b-card>
            </b-col>
            <b-col md="6" class="mb-3">
              <b-card>
                <h6>Notas Médias por Curso/Módulo</h6>
                <p class="text-muted">Análise de dificuldade do conteúdo</p>
                <b-button
                  variant="primary"
                  size="sm"
                  @click="loadAverageGrades"
                >
                  <i class="fa fa-bar-chart"></i> Gerar Relatório
                </b-button>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>

        <!-- RELATÓRIOS DE ENGAJAMENTO -->
        <b-tab title="Engajamento">
          <h5 class="mb-3">Relatórios de Engajamento</h5>
          <b-row>
            <b-col md="6" class="mb-3">
              <b-card>
                <h6>Taxa de Abandono</h6>
                <p class="text-muted">
                  Alunos que iniciaram mas não concluíram
                </p>
                <b-button
                  variant="warning"
                  size="sm"
                  @click="loadAbandonmentRate"
                >
                  <i class="fa fa-user-times"></i> Gerar Relatório
                </b-button>
              </b-card>
            </b-col>
            <b-col md="6" class="mb-3">
              <b-card>
                <h6>Frequência de Acesso</h6>
                <p class="text-muted">
                  Quantas vezes os alunos acessam o sistema
                </p>
                <b-button variant="info" size="sm" @click="loadAccessFrequency">
                  <i class="fa fa-calendar"></i> Gerar Relatório
                </b-button>
              </b-card>
            </b-col>
            <b-col md="6" class="mb-3">
              <b-card>
                <h6>Materiais Mais Acessados</h6>
                <p class="text-muted">Quais conteúdos têm mais visualizações</p>
                <b-button
                  variant="info"
                  size="sm"
                  @click="loadMostAccessedMaterials"
                >
                  <i class="fa fa-star"></i> Gerar Relatório
                </b-button>
              </b-card>
            </b-col>
            <b-col md="6" class="mb-3">
              <b-card>
                <h6>Horários de Pico de Acesso</h6>
                <p class="text-muted">Quando os alunos mais estudam</p>
                <b-button variant="info" size="sm" @click="loadPeakHours">
                  <i class="fa fa-line-chart"></i> Gerar Relatório
                </b-button>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>

        <!-- RELATÓRIOS DE COMPLIANCE -->
        <b-tab title="Compliance">
          <h5 class="mb-3">Relatórios de Compliance</h5>
          <b-row>
            <b-col md="6" class="mb-3">
              <b-card>
                <h6>Status de Certificações</h6>
                <p class="text-muted">
                  Quem está certificado, próximo ao vencimento ou vencido
                </p>
                <b-button
                  variant="success"
                  size="sm"
                  @click="loadCertificationsStatus"
                >
                  <i class="fa fa-certificate"></i> Gerar Relatório
                </b-button>
              </b-card>
            </b-col>
            <b-col md="6" class="mb-3">
              <b-card>
                <h6>Prazos Críticos</h6>
                <p class="text-muted">Alunos/turmas com deadlines próximos</p>
                <b-button
                  variant="danger"
                  size="sm"
                  @click="loadCriticalDeadlines"
                >
                  <i class="fa fa-exclamation-triangle"></i> Gerar Relatório
                </b-button>
              </b-card>
            </b-col>
            <b-col md="6" class="mb-3" v-if="isRoot">
              <b-card>
                <h6>Conformidade por Empresa</h6>
                <p class="text-muted">
                  Percentual de colaboradores em dia com treinamentos
                </p>
                <b-button
                  variant="primary"
                  size="sm"
                  @click="loadComplianceByCompany"
                >
                  <i class="fa fa-building"></i> Gerar Relatório
                </b-button>
              </b-card>
            </b-col>
            <b-col md="6" class="mb-3">
              <b-card>
                <h6>Alertas de Não Conformidade</h6>
                <p class="text-muted">Identificação de gaps de treinamento</p>
                <b-button
                  variant="danger"
                  size="sm"
                  @click="loadNonComplianceAlerts"
                >
                  <i class="fa fa-bell"></i> Gerar Relatório
                </b-button>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>

        <!-- RELATÓRIOS GERENCIAIS -->
        <b-tab title="Gerencial">
          <h5 class="mb-3">Relatórios Gerenciais</h5>
          <b-row>
            <b-col md="6" class="mb-3">
              <b-card>
                <h6>Dashboard Executivo</h6>
                <p class="text-muted">
                  Visão consolidada de todas as métricas principais
                </p>
                <b-button
                  variant="primary"
                  size="sm"
                  @click="loadExecutiveDashboard"
                >
                  <i class="fa fa-dashboard"></i> Gerar Relatório
                </b-button>
              </b-card>
            </b-col>
            <b-col md="6" class="mb-3">
              <b-card>
                <h6>Comparativo entre Turmas</h6>
                <p class="text-muted">
                  Performance relativa entre diferentes grupos
                </p>
                <b-button
                  variant="info"
                  size="sm"
                  @click="loadClassesComparison"
                >
                  <i class="fa fa-users"></i> Gerar Relatório
                </b-button>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>

        <!-- RELATÓRIOS DE QUALIDADE -->
        <b-tab title="Qualidade">
          <h5 class="mb-3">Relatórios de Qualidade</h5>
          <b-row>
            <b-col md="6" class="mb-3">
              <b-card>
                <h6>Avaliações de Satisfação</h6>
                <p class="text-muted">Feedback dos alunos sobre os cursos</p>
                <b-button
                  variant="success"
                  size="sm"
                  @click="loadSatisfactionRatings"
                >
                  <i class="fa fa-smile-o"></i> Gerar Relatório
                </b-button>
              </b-card>
            </b-col>
            <b-col md="6" class="mb-3">
              <b-card>
                <h6>Pontos de Dificuldade</h6>
                <p class="text-muted">Módulos/questões com mais erros</p>
                <b-button
                  variant="warning"
                  size="sm"
                  @click="loadDifficultyPoints"
                >
                  <i class="fa fa-question-circle"></i> Gerar Relatório
                </b-button>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>

        <!-- MÉTRICAS AVANÇADAS -->
        <b-tab title="Métricas Avançadas">
          <h5 class="mb-3">Métricas Avançadas</h5>
          <b-row>
            <b-col md="6" class="mb-3">
              <b-card>
                <h6>Curva de Aprendizagem</h6>
                <p class="text-muted">Velocidade de absorção do conteúdo</p>
                <b-button variant="info" size="sm" @click="loadLearningCurve">
                  <i class="fa fa-area-chart"></i> Gerar Relatório
                </b-button>
              </b-card>
            </b-col>
            <b-col md="6" class="mb-3">
              <b-card>
                <h6>Padrões de Abandono</h6>
                <p class="text-muted">Em que momento os alunos desistem</p>
                <b-button
                  variant="warning"
                  size="sm"
                  @click="loadAbandonmentPatterns"
                >
                  <i class="fa fa-signal"></i> Gerar Relatório
                </b-button>
              </b-card>
            </b-col>
            <b-col md="6" class="mb-3">
              <b-card>
                <h6>Correlações</h6>
                <p class="text-muted">
                  Relação entre variáveis (ex: tempo de estudo vs nota)
                </p>
                <b-button variant="primary" size="sm" @click="loadCorrelations">
                  <i class="fa fa-puzzle-piece"></i> Gerar Relatório
                </b-button>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>

        <!-- EXPORTAÇÕES -->
        <b-tab title="Exportar">
          <h5 class="mb-3">Relatórios Customizados</h5>
          <b-card>
            <b-form @submit.prevent="loadCustomReport">
              <b-row>
                <b-col md="6">
                  <b-form-group label="Curso:">
                    <b-form-select
                      v-model="customFilters.courseId"
                      :options="courseOptions"
                    >
                      <template slot="first">
                        <option :value="null">Todos os cursos</option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Período:">
                    <b-row>
                      <b-col>
                        <b-form-input
                          type="date"
                          v-model="customFilters.startDate"
                          placeholder="Data inicial"
                        />
                      </b-col>
                      <b-col>
                        <b-form-input
                          type="date"
                          v-model="customFilters.endDate"
                          placeholder="Data final"
                        />
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-button type="submit" variant="primary">
                <i class="fa fa-download"></i> Gerar e Exportar
              </b-button>
            </b-form>
          </b-card>
        </b-tab>
      </b-tabs>

      <!-- Modal de Resultados -->
      <b-modal
        v-model="showReportModal"
        size="xl"
        :title="reportTitle"
        ok-only
        ok-title="Fechar"
      >
        <div v-if="loading" class="text-center">
          <b-spinner variant="primary"></b-spinner>
          <p class="mt-2">Carregando relatório...</p>
        </div>
        <div v-else>
          <pre>{{ JSON.stringify(reportData, null, 2) }}</pre>
        </div>
      </b-modal>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as eadApi from "@/api/ead";

export default {
  name: "RelatoriosEAD",
  data() {
    return {
      activeTab: 0,
      loading: false,
      showReportModal: false,
      reportTitle: "",
      reportData: null,
      customFilters: {
        courseId: null,
        startDate: null,
        endDate: null,
      },
      courseOptions: [],
    };
  },
  computed: {
    ...mapGetters(["role"]),
    isRoot() {
      return this.role === "root";
    },
  },
  mounted() {
    this.loadCourses();
  },
  methods: {
    async loadCourses() {
      try {
        const response = await eadApi.getCourses();
        this.courseOptions = response.data.map((course) => ({
          value: course._id,
          text: course.nome,
        }));
      } catch (error) {
        console.error("Erro ao carregar cursos:", error);
      }
    },

    async showReport(title, apiCall) {
      this.reportTitle = title;
      this.loading = true;
      this.showReportModal = true;
      this.reportData = null;

      try {
        const response = await apiCall();
        this.reportData = response.data;
      } catch (error) {
        console.error("Erro ao carregar relatório:", error);
        this.$message.error("Erro ao carregar relatório");
        this.showReportModal = false;
      } finally {
        this.loading = false;
      }
    },

    // Relatórios de Desempenho
    loadCompletionByCourse() {
      this.showReport("Taxa de Conclusão por Curso", () =>
        eadApi.getCompletionByCourse()
      );
    },
    loadAverageCompletionTime() {
      this.showReport("Tempo Médio de Conclusão", () =>
        eadApi.getAverageCompletionTime()
      );
    },
    loadApprovalRate() {
      this.showReport("Taxa de Aprovação/Reprovação", () =>
        eadApi.getApprovalRate()
      );
    },
    loadAverageGrades() {
      this.showReport("Notas Médias por Curso/Módulo", () =>
        eadApi.getAverageGrades()
      );
    },

    // Relatórios de Engajamento
    loadAbandonmentRate() {
      this.showReport("Taxa de Abandono", () => eadApi.getAbandonmentRate());
    },
    loadAccessFrequency() {
      this.showReport("Frequência de Acesso", () =>
        eadApi.getAccessFrequency()
      );
    },
    loadMostAccessedMaterials() {
      this.showReport("Materiais Mais Acessados", () =>
        eadApi.getMostAccessedMaterials()
      );
    },
    loadPeakHours() {
      this.showReport("Horários de Pico de Acesso", () =>
        eadApi.getPeakHours()
      );
    },

    // Relatórios de Compliance
    loadCertificationsStatus() {
      this.showReport("Status de Certificações", () =>
        eadApi.getCertificationsStatus()
      );
    },
    loadCriticalDeadlines() {
      this.showReport("Prazos Críticos", () => eadApi.getCriticalDeadlines());
    },
    loadComplianceByCompany() {
      this.showReport("Conformidade por Empresa", () =>
        eadApi.getComplianceByCompany()
      );
    },
    loadNonComplianceAlerts() {
      this.showReport("Alertas de Não Conformidade", () =>
        eadApi.getNonComplianceAlerts()
      );
    },

    // Relatórios Gerenciais
    loadExecutiveDashboard() {
      this.showReport("Dashboard Executivo", () =>
        eadApi.getExecutiveDashboard()
      );
    },
    loadClassesComparison() {
      this.showReport("Comparativo entre Turmas", () =>
        eadApi.getClassesComparison()
      );
    },

    // Relatórios de Qualidade
    loadSatisfactionRatings() {
      this.showReport("Avaliações de Satisfação", () =>
        eadApi.getSatisfactionRatings()
      );
    },
    loadDifficultyPoints() {
      this.showReport("Pontos de Dificuldade", () =>
        eadApi.getDifficultyPoints()
      );
    },

    // Métricas Avançadas
    loadLearningCurve() {
      this.showReport("Curva de Aprendizagem", () => eadApi.getLearningCurve());
    },
    loadAbandonmentPatterns() {
      this.showReport("Padrões de Abandono", () =>
        eadApi.getAbandonmentPatterns()
      );
    },
    loadCorrelations() {
      this.showReport("Correlações", () => eadApi.getCorrelations());
    },

    // Relatório Customizado
    loadCustomReport() {
      const filters = {};
      if (this.customFilters.courseId)
        filters.courseId = this.customFilters.courseId;
      if (this.customFilters.startDate)
        filters.startDate = this.customFilters.startDate;
      if (this.customFilters.endDate)
        filters.endDate = this.customFilters.endDate;

      this.showReport("Relatório Customizado", () =>
        eadApi.getCustomReport(filters)
      );
    },
  },
};
</script>

<style scoped>
.b-card {
  height: 100%;
}

.b-card h6 {
  color: #2c3e50;
  font-weight: bold;
  margin-bottom: 10px;
}

.text-muted {
  font-size: 0.9rem;
  margin-bottom: 15px;
}

pre {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 5px;
  max-height: 500px;
  overflow-y: auto;
}
</style>
